const searchV2 = resolve => require(['../view/common/search'], resolve)
const payIndex = resolve => require(['@/view/common/pay/index'], resolve)
const paySuccess = resolve => require(['@/view/common/pay/success'], resolve)
const college = resolve => require(['@/view/common/college'], resolve)
const rule = resolve => require(['@/view/common/rule'], resolve)
const announcement = resolve => require(['@/view/common/announcement'], resolve)
const routes = [
  {
    path: '/common/search',
    name: '/common/search',
    component: searchV2,
    meta: {
    }
  },{
    path: '/common/pay/index',
    name: '/common/pay/index',
    component: payIndex,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/common/pay/success',
    name: '/common/pay/success',
    component: paySuccess,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/common/college',
    name: '/common/college',
    component: college,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/common/rule',
    name: '/common/rule',
    component: rule,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/common/announcement',
    name: '/common/announcement',
    component: announcement,
    meta: {
      // requireAuth: true
    }
  }]
export default {routes}



// WEBPACK FOOTER //
// ./src/router/common.js